import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 690C3986-7EEB-4DD2-87EE-BEB93A917B14
 * name moon-last-quarter
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/moon-last-quarter.svg
 * tags
 * - Weather 
 */
export const MoonLastQuarterIcon = createSvgIcon(<><path d="M12 2A10 10 0 0 0 12 22Z" /></>, 'MoonLastQuarterIcon');
export default MoonLastQuarterIcon